import { defineMessages } from 'react-intl-next';

export default defineMessages({
    searchPlaceholder: {
        defaultMessage: 'Search all',
        description:
            'Placeholder for assets picker field to advise the user to search for all assets (even after an initial load of assets)',
        id: 'cv.request.create.form.assets.picker.search',
    },
    noOptions: {
        defaultMessage: 'No options',
        description: 'Text that appears in the dropdown for the assets picker if there are no assets to select',
        id: 'cv.request.create.form.assets.picker.no.options',
    },
    typeToSearch: {
        defaultMessage: 'Type to search',
        description:
            'Text that appears in the dropdown for the assets picker if the user needs to search to find assets',
        id: 'cv.request.create.form.assets.picker.type.to.search',
    },
});
